import TEXTS from '@/data/blocks/texts.json'
import IMAGE from '@/data/blocks/image.json'
import DIVIDER from '@/data/blocks/divider.json'
import LINKS from '@/data/blocks/links.json'
import CODE from '@/data/blocks/code.json'
import QUOTE from '@/data/blocks/quote.json'

export default {
  TEXTS,
  IMAGE,
  DIVIDER,
  LINKS,
  QUOTE,
  CODE,
}
